import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Col, Row, Grid } from 'react-bootstrap';
import Shimmer from './Shimmer';
import s from '../Home/HomeKindofTrip/HomeKindofTrip.css';
import l from './Skeleton.css';

function HomePopularSkeleton() {
  return (
    <div className={cx(s.container, 'homeKindTripBorderRadius')}>
      <Grid fluid className={s.containerPadding}>
        <div className={s.homeFind}>
          <div className={s.homeFindMain}>
            <Row className={cx(s.SectionPadding)}>
              {[1, 2].map((_, index) => (
                <Col
                  key={index}
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className={index === 1 ? cx(s.paddingTopMobile) : undefined}
                >
                  <div className={s.bgSection}>
                    <div className={cx(s.homeFindBg, l.skeletonBoxBg, l.homeFindBgMain)}>
                      <Shimmer />
                      <div className={cx(l.homeKindPositionSkeleton, 'homeKindPositionSkeletonRTL')}>
                        <div className={cx(l.homeKindOneSkeleton, 'bgBlackTwo')}>
                          <Shimmer />
                        </div>
                        <div
                          className={cx(
                            l.homeKindOneSkeleton,
                            'homeKindOneSkeletonWidthRTL',
                            index === 0 ? 'bgBlackTwo' : null
                          )}
                          style={{ width: '400px' }}
                        >
                          <Shimmer />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </Grid>
    </div>
  );
}

export default withStyles(s, l)(HomePopularSkeleton);
